import script from "./remap-dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./remap-dropdown.vue?vue&type=script&setup=true&lang=ts"

import "./remap-dropdown.vue?vue&type=style&index=0&id=26f5bdf4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f5bdf4"]])

export default __exports__